import { useState } from "react";

// Import sparkline
import { Sparklines, SparklinesLine } from "react-sparklines";

// Import hooks and utils
import { useOrderAnalytics } from "../hooks/orderAnalytics/useOrderAnalytics";

// Import reusable components
import DateRangeSelector from "./DateRangeSelector";
import OrderStatTile from "./OrderStatTile";

const NEUTRAL_COMPARISON = { value: 0, direction: "neutral" };

export default function OrdersAnalyticsSummary({ allOrders }) {
  const [range, setRange] = useState("today");

  // Fetch the analytics values
  const analytics = useOrderAnalytics();

  return (
    <div className="mb-6 rounded-lg bg-white border border-[#e4e4e4] py-3 shadow-sm">
      <div className="flex">
        <div className="min-w-[10em] flex items-center">
          <DateRangeSelector className="" value={range} onChange={setRange} />
        </div>
        
        {/* Statistics Tiles */}
        <div className="flex justify-between w-full">
          {analytics.map((metric) => {
            const hasValidSparkline = Boolean(metric.hasValidSparkline);
            const sparklineColor = hasValidSparkline
              ? metric.isPositive ? "#16a34a" : "#dc2626"
              : "#9ca3af";
            const comparison = hasValidSparkline ? metric.comparison : NEUTRAL_COMPARISON;
            const overridePositive = hasValidSparkline ? metric.isPositive : undefined;

            return (
              <OrderStatTile
                key={metric.label}
                label={metric.label}
                value={metric.displayValue ?? metric.value}
                unit={metric.unit}
                comparison={comparison}
                isPositive={overridePositive}
                sparkline={
                  <Sparklines data={metric.sparkline} width={120} height={30}>
                    <SparklinesLine color={sparklineColor} />
                  </Sparklines>
                }
              />
            );
          })}
        </div>
      
      </div>
    </div>
  );
}